<template>
  <v-autocomplete
    v-model="selected"
    :class="{ 'red lighten-4': selected && selected.isRemoved }"
    class="append-add-icon"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :rules="rules"
    :clearable="clearable"
    :label="label"
    return-object
    hide-details
    hide-selected
    :disabled="readonly"
    browser-autocomplete="nope"
    :outline="outline !== undefined ? outline : true"
    no-filter
    no-data-text="Данные не выбраны"
    :height="heightField !== undefined ? heightField : 44"
    clear-icon="close"
    :menu-props="menuPropsClose"
    prepend-inner-icon="folder_open"
    @change="handleItemChange"
    @click:clear="clear"
    @click="closeMenuPropsOnClick(false)"
  >
    <template v-slot:append>
      <AddReferenceBtn @click="createNew" />
    </template>
  </v-autocomplete>
</template>
<script>
import AddReferenceBtn from "../AddReferenceBtn.vue";
import CloseDropdownList from "../../mixins/close-dropdown-list.js";
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
import * as addressesApi from "../../backend/addressesApi.js";

export default {
  components: { AddReferenceBtn },
  mixins: [CloseDropdownList],
  props: [
    "value",
    "label",
    "rules",
    "resource",
    "parentId",
    "parentFilter",
    "dataRestored",
    "disabled",
    "disableAdd",
    "parentLoading",
    "withoutParentLock",
    "withoutClearable",
    "componentName",
    "filterName",
    "filterValue",
    "outline",
    "heightField",
  ],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      loading: false,
    };
  },
  computed: {
    readonly() {
      if (this.withoutParentLock) {
        return this.disabled || this.parentLoading;
      }
      return (
        this.disabled ||
        (this.parentFilter && !this.parentIdValue) ||
        this.parentLoading
      );
    },
    watchOnParent() {
      return this.dataRestored;
    },
    parentIdValue() {
      return this.parentId ? this.parentId : null;
    },
    clearable() {
      return !this.withoutClearable;
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.value) {
          this.selected = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (this.selected && this.value.id === this.selected.value) {
          return;
        }
        const selectedItem = this.items.find(i => i.value === this.value.id);
        if (selectedItem) {
          this.selected = selectedItem;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.fetchAll();
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.selected && this.selected.text === this.search) {
        return;
      }

      this.loading = true;
      setTimeout(() => {
        if (!this.search) {
          this.selected = null;
          this.items = [];
          this.loading = false;
          return;
        }

        let queryParams = `searchTerm=${this.search}`;
        if (this.parentFilter) {
          queryParams += `&${this.parentFilter}=${this.parentIdValue}`;
        }
        if (this.filterName !== undefined && this.filterValue !== undefined) {
          queryParams += `&${this.filterName}=${this.filterValue}`;
        }

        this.searchReference(queryParams);
        this.loading = false;
      }, 500);
    },
    parentId(newId, oldId) {
      if (!this.watchOnParent) {
        return;
      }
      if (oldId && newId !== oldId) {
        this.selected = null;
        this.items = [];
      }
    },
  },
  created() {
    if (this.value) {
      this.setSelectedElement(this.value);
    }
    NestedEditorsEventBus.$on("create-" + this._uid, createdId => {
      this.getReference(createdId);
      this.handleItemChange();
    });
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      newVal => {
        if (newVal) {
          this.fetchAll();
        } else {
          this.clear();
        }
      },
    );
  },
  methods: {
    async handleItemChange() {
      if (this.selected) {
        const res = await addressesApi.getAddressReference(
          this.resource,
          this.selected.value,
        );
        this.$emit("input", {
          id: this.selected.value,
          title: this.selected.text,
          country: {
            id: res.country.id,
            title: res.country.title,
          },
        });
      } else {
        this.$emit("input", null);
      }
    },
    async fetchAll() {
      let queryParams = "";
      if (this.parentFilter && this.parentIdValue) {
        queryParams = `${this.parentFilter}=${this.parentIdValue}`;
      }
      if (this.filterName && this.filterValue) {
        queryParams =
          queryParams === ""
            ? `${this.filterName}=${this.filterValue}`
            : `${queryParams}&${this.filterName}=${this.filterValue}`;
      }
      this.items = await addressesApi.getQueryReference(
        this.resource,
        queryParams,
      );

      if (this.selected) {
        const selectedItem = this.items.find(
          i => i.value === this.selected.value,
        );
        if (!selectedItem) {
          this.items.push({
            value: this.selected.value,
            text: this.selected.text,
          });
        }
      }

      this.loading = false;
    },
    clear() {
      this.items = [];
      if (this.selected) {
        this.items.push(this.selected);
      }
    },
    createNew() {
      this.closeMenuPropsOnClick(true);
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
      });
    },
    setSelectedElement(value) {
      const newItem = {
        text: value.title,
        value: value.id,
        isRemoved: value.isRemoved,
      };
      this.items.push(newItem);
      this.selected = newItem;
    },
    async getReference(id) {
      const res = await addressesApi.getAddressReference(this.resource, id);
      this.setSelectedElement(res);
    },
    async searchReference(queryParams) {
      this.items = await addressesApi.getQueryReference(
        this.resource,
        queryParams,
      );
    },
  },
};
</script>
<style>
.append-add-icon .v-input__icon--append .v-icon {
  -webkit-transform: none !important;
  transform: none !important;
}
.append-add-icon
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner
  .v-input__icon
  .v-icon {
  color: grey !important;
}
.append-add-icon
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner
  .v-input__icon
  .v-icon:hover {
  color: #424242 !important;
}
</style>
